import apiTrainerResults from '@/api/trainer-result'

const state = {
  error: null,
  isSubmitting: false,
}

export const mutationTypes = {
  createTrainerResultStart:
    '[create trainer result] Create trainer result start',
  createTrainerResultSuccess:
    '[create trainer result] Create trainer result success',
  createTrainerResultFailure:
    '[create trainer result] Create trainer result failure',
}

export const actionTypes = {
  createTrainerResult: '[create trainer result] Create trainer result',
}

const mutations = {
  [mutationTypes.createTrainerResultStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.createTrainerResultSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createTrainerResultFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },
}

const actions = {
  [actionTypes.createTrainerResult](context, {trainerResult}) {
    context.commit(mutationTypes.createTrainerResultStart)
    return new Promise((resolve) => {
      apiTrainerResults
        .createTrainerResult(trainerResult)
        .then((response) => {
          context.commit(mutationTypes.createTrainerResultSuccess)
          resolve(response.data)
        })
        .catch((resolve) => {
          context.commit(
            mutationTypes.createTrainerResultFailure,
            resolve.response.data.errors
          )
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
